// หน้าจอ "ฐานข้อมูลกำลังเปิด" — ระหว่าง schema inbound รอ Supabase restart (PGRST106)
export default function DbPending({ onRetry }) {
  return (
    <div className="placeholder">
      <h2>ฐานข้อมูลกำลังเปิด</h2>
      <p>ระบบหลังบ้าน (Supabase) กำลังเปิด schema ของแอพให้ใช้งาน — จะพร้อมเองโดยไม่ต้องทำอะไร
        ลองกดใหม่อีกครั้งภายหลัง</p>
      {onRetry && <button className="tab" onClick={onRetry}>ลองใหม่</button>}
    </div>
  );
}
